import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"
import apiResponse from '../../../../services/apiResponse'
import SubmitBloc from './Blocs/SubmitBloc'
import { accessRole } from "../../../../helpers/access_role"
import { withRouter } from "react-router";

class IndexView extends Component {

    submitBloc = new SubmitBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {
                emp_retired_sk_date: "",
                uuid: "",
                nip: "",
                nama: "",
                unit_kerja: "",
                jabatan: "",
                tmt_jabatan: "",
                tgl_pensiun:"",
                golongan: "",
                tgl_lahir: "",
                jenis_kelamin: "",
                tmt_pensiun: "",
                usia: "",
                usia_pensiun: "",
                sisa_masa_kerja: "",
                posisi:""
            },
            submission_uuid: "",
            employeeItems: [],
            employeeSelected: "",
        }
    }

    submitData = async () => {
        if(this.state.dataForm.document.length > 0){
            let formData = generateFormData(this.state.dataForm, 'document')
            await this.submitBloc.fetchSubmit(formData)
        }else{
            await this.submitBloc.fetchSubmit(this.state.dataForm)
        }      
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              ...values
            },
            confirm: true
        })
    }



    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {

        this.submitBloc.submitChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.submitBloc.employeeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        // console.log(response)
                        this.setState({
                            dataForm: {
                                uuid: response.retired_employee_uuid,
                                nip: response.retired_employee_nip,
                                nama: response.retired_employee_name,
                                posisi: response.retired_employee_position_name,
                                unit_kerja: response.retired_employee_work_unit_name,
                                tgl_pensiun : response.retired_employee_retired_date,
                                sisa_masa_kerja: response.employee_work_age
                            },
                            submission_uuid: response.retired_employee_submission_uuid
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
         })

        const queryParams = new URLSearchParams(window.location.search).get('uuid')
        this.submitBloc.fetchEmployee({uuid: queryParams })
        
    }

    

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                           

                            <Card className="">
                                <CardBody>
                                    <CardTitle>Verifikasi Usulan Pensiun</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        <AvField
                                            name="retired_employee_uuid"
                                            type="hidden"
                                            id="retired_employee_uuid"
                                            value={this.state.dataForm.uuid}
                                        />

                                         <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            NIP
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="nip"
                                                    id="nip"
                                                    readonly="readOnly"
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.dataForm.nip}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nama 
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="nama"
                                                    id="nama"
                                                    readonly="readOnly"
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.dataForm.nama}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Posisi 
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="posisi"
                                                    id="posisi"
                                                    readonly="readOnly"
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.dataForm.posisi}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Unit Kerja
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="unit_kerja"
                                                    id="unit_kerja"
                                                    readonly="readOnly"
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.dataForm.unit_kerja}
                                                />
                                            </Col>
                                        </Row>

                                         <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Pensiun
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="tgl_pensiun"
                                                    id="tgl_pensiun"
                                                    readonly="readOnly"
                                                    className="form-control"
                                                    value={this.state.dataForm.tgl_pensiun}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Masa Kerja
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="masa_kerja"
                                                    id="masa_kerja"
                                                    readonly="readOnly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.sisa_masa_kerja}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal SK  <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="emp_retired_sk_date"
                                                    id="emp_retired_sk_date"
                                                    type="date"
                                                    className="form-control"
                                                    value={this.state.dataForm.emp_retired_sk_date}
                                                />
                                            </Col>
                                        </Row>

                                       <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            TMT Pensiun <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder="TMT Pensiun"
                                                    name="tmt_pensiun"
                                                    id="tmt_pensiun"
                                                    type="date"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>


                                         <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            No BKN <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder="Nomor BKN"
                                                    name="no_bkn"
                                                    id="no_bkn"
                                                    type="form-control"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                         <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal BKN <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder="Tanggal BKN"
                                                    name="tgl_bkn"
                                                    id="tgl_bkn"
                                                    type="date"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                          <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nomor SK Pensiun <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder="Nomor SK Pensiun"
                                                    name="no_sk_pensiun"
                                                    id="no_sk_pensiun"
                                                    type="form-control"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            File SK <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                <FileInput 
                                                    name="document"
                                                />
                                            </Col>
                                        </Row>

                                        
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to={`?pegawai&uuid=`+this.state.submission_uuid}>
                                                    <Button color="warning"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-check"></i> Verifikasi
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan memverikasi data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil diverifikasi"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal diverifikasi"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                     <Redirect to={`/kepegawaian/pensiun.html?pegawai&uuid=`+this.state.submission_uuid}/>
                : null }
            </Fragment>
        )
    }

}

export default withRouter(IndexView);